import {
  Button,
  Modal,
  Divider,
  Form,
  Input,
  message,
  Upload,
  Row,
  Col,
  Spin,
  Progress
} from "antd";
import React, { useEffect, useState, useRef } from "react";
import { useMsal } from "@azure/msal-react";
import envConfig from "../config.json";
import {
  UploadOutlined,
  PlusOutlined,
  PlayCircleOutlined,
  CloudUploadOutlined,
  ExclamationCircleFilled
} from "@ant-design/icons";

import "@google/model-viewer/dist/model-viewer";
import axios from "axios";
import PropTypes from 'prop-types'
import { twinButton, modelUploadNote, errorredNote } from "../StyleObj";
import { useTheme } from "../components/ThemeContext";

const ERRORNOTETEXT = "Minimum 3 and Max 25 characters (Alphanumeric,_only)";
const CHAR_LIMIT = 25;
const {
  AnonymousCredential,
  BlobServiceClient,
  newPipeline,
} = require("@azure/storage-blob");

/**
 * Component to manage the asset upload
 */
const AssetUpload = (props) => {
  AssetUpload.propTypes = {
    fetchModels: PropTypes.any,
    selectedPlant: PropTypes.any,
    plantName: PropTypes.any,
    sas: PropTypes.any
  };
  const { instance } = useMsal();
  const { fetchModels, selectedPlant, plantName } = props;
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [title, setTitle] = useState("");
  const [tag, setTag] = useState("");
  const [icon, setIcon] = useState();
  const [asset, setAsset] = useState();
  const [showProgress, setShowProgress] = useState(false);
  const [previewImage, setPreviewImage] = useState();
  const [formKey, setFormKey] = useState(0);
  const [assetValidation, setAssetValidation] = useState(false);
  const [thumbnailValidation, setThumbnailValidation] = useState(false);
  const [uploadPercentage, setUploadPercentage] = useState(0);
  const [isUpload, setIsUpload] = useState(false);
  const [isSaving, setIsSaving] = useState(true);
  const [file, setFile] = useState();
  const [titleCheck, setTitleCheck] = useState(false);
  const inputRef = useRef(null);
  const msalToken = localStorage.getItem("msal.accesstoken");
  const { theme } = useTheme();
  /**
   * Function to handle the icon settings
   * @param {*} e
   */
  const removeFile = () => {
    setAsset("");
    setFile("");
  };
  const handleIcon = (e) => {
    const isJpgOrPng =
      e.file.type === "image/jpeg" || e.file.type === "image/png";
    const isLt2M = e.file.size / 1024 / 1024 < 10;
    if (!isJpgOrPng) {
      message.error({
        content: "You can only upload JPG/PNG file",
        className: 'custom-message-failure',
      });
      setThumbnailValidation(true);
      return;
    } else if (!isLt2M) {
      message.error({
        content: "Image must smaller than 10MB",
        className: 'custom-message-failure',
      });
      return;
    }
    const result = URL.createObjectURL(e.file);
    setPreviewImage(result);
    setIcon(e.file);

    setThumbnailValidation(false);
  };
  /**
   * Function to handle the uploading of a model file
   * @param {*} file file to be upload
   */
  const blobUpload = async (file) => {
    const account = envConfig.storageAccount;
    const containerName = envConfig.containerName;
    const orgDir = "AOT";
    let ext = file.name.toLowerCase().split(".");
    ext = ext[ext.length - 1];
    const index = file.name.lastIndexOf(".");
    const name = file.name.substr(0, index);
    const pipeline = newPipeline(new AnonymousCredential(), {
      retryOptions: { maxTries: 4 }, // Retry options
      userAgentOptions: { userAgentPrefix: "AdvancedSample V1.0.0" }, // Customized telemetry string
      keepAliveOptions: {
        enable: false,
      },
    });
    const blobServiceClient = new BlobServiceClient(
      `https://${account}.blob.core.windows.net?${props.sas}`,
      pipeline
    );
    const containerClient = blobServiceClient.getContainerClient(containerName);
    const fileName = `${name}${Date.now()}.${ext}`;
    const blobName = orgDir + "/" + fileName;
    const blockBlobClient = containerClient.getBlockBlobClient(blobName);
    let url = blockBlobClient.url.split("?");
    url = url[0];
    try {
      await blockBlobClient.uploadData(file, {
        blockSize: 4 * 1024 * 1024, // 4MB block size
        concurrency: 20, // 20 concurrency
        onProgress: (ev) => console.log(ev),
      });
      const fileDetails = {
        name: fileName,
        ext: ext,
        size: file.size,
        url: url,
      };
      return JSON.stringify(fileDetails);
    } catch (err) {
      console.error(
        `uploadFile failed, requestId - ${err.details.requestId}, statusCode - ${err.statusCode}, errorCode - ${err.details.errorCode}`
      );
    }
  };
  /**
   * Function to reset the fields
   */
  const resetFields = () => {
    setFormKey((formKey || 0) + 1);
    setTitle("");
    setTag("");
    setIcon();
    setAsset();
    setFile("");
    setPreviewImage(null);
    setIsUpload(false);
    setTitleCheck(false);
  };
  /**
   * Function to save the asset
   */
  const saveModel = async () => {
    if (title && asset && icon) {
      setShowProgress(true);
      setIsUpload(true);
      setTitleCheck(false);
      const assetDetails = await blobUpload(asset);
      setUploadPercentage(30);
      const thumbnailDetails = await blobUpload(icon);
      setUploadPercentage(70);
      const uploadFields = {
        title: title,
        asset: JSON.parse(assetDetails),
        icon: JSON.parse(thumbnailDetails),
        tag: tag,
        plantId: selectedPlant,
      };
      const config = {
        headers: {
          Authorization: `Bearer ${msalToken}`,
        },
        "Content-Type": "application/x-www-form-urlencoded",
      };
      axios
        .post(`${envConfig.aotmwapi}/api/3d-cms/content`, uploadFields, config)
        .then((response) => {
          setUploadPercentage(100);
          setShowProgress(false);
          message.success({
            content: "Model uploaded successfully",
            className: 'custom-message-success'
          });
          resetFields();
          setIsModalVisible(false);
          setIsUpload(false);
          fetchModels();
        })
        .catch((error) => {
          if (error.response.status === 401) {
            localStorage.removeItem("checkRole");
            const logoutRequest = {
              postLogoutRedirectUri: envConfig.redirectUri,
            };
            instance.logoutRedirect(logoutRequest);
          } else {
            message.error({
              content: "Model uploaded failed please try again",
              className: 'custom-message-failure',
            });
            setShowProgress(false);
            resetFields();
            setIsModalVisible(false);
            setIsUpload(false);
          }
          console.error("error in saveModel Api");
        });
    } else {
      alert("please fill all fileds");
    }

    props.setSearchText('');
    props.fetchModels();
  };
  /**
   * Function to handle the file props thumnail
   */
  const filePropsThumbnail = {
    name: "files",
    multiple: false,
    onChange(info) {
      const { status } = info.file;
      if (status === "error") {
        message.error({
          content: `${info.file.name} file upload failed.`,
          className: 'custom-message-failure',
        });
      }
    },
    beforeUpload() {
      return false;
    },
  };
  /**
   * Function to show the modal
   */
  const showModal = () => {
    setIsModalVisible(true);
  };
  /**
   * Function to validate selected files
   */
  const validateSelectedFiles = (value) => {
    if (value.fileList.length > 0) {
      let ext = value.file.name.toLowerCase().split(".");
      ext = ext[ext.length - 1];
      if (ext === "gltf" || ext === "glb") {
        setAssetValidation(false);
        setFile(window.URL.createObjectURL(value.file));
        setAsset(value.file);
      } else {
        setAssetValidation(true);
        setThumbnailValidation(false);
        setFile("");
        setAsset("");
        message.error({
          content: "You can only upload GLB/GLTF file",
          className: 'custom-message-failure',
        });
        return;
      }
    } else {
      setFile("");
      setAsset("");
      setAssetValidation(false);
    }
  };

  /**
   * Function to handle the cancel of modal
   */
  const handleCancel = () => {
    resetFields();
    setIsModalVisible(false);
    props.setSearchText('');
    props.fetchModels();
    setThumbnailValidation(false);
  };

  /**
   * Effect to set the initial value from the ref
   */
  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.input.value = "";
    }
  }, []);

  /**
   * React hook to handle side effect
   */
  useEffect(() => {
    if (title && asset && icon) {
      setIsSaving(false);
    } else {
      setIsSaving(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [title, asset, icon]);


  // restricting user to enter only valid characters
  const handleTitleChange = (e) => {
    const { value } = e.target;
    // Regular expression to ensure input text does not start with a number or an underscore
    const startsWithValidCharPattern = /^[a-zA-Z]\w*$/;
    // Check if the input value is valid
    const isValid = startsWithValidCharPattern.test(value);
    setTitle(value);
    // Check if the length of the value is within the limit and it passes the validation pattern
    if (value.length <= CHAR_LIMIT && isValid) {
      inputRef.current.input.value = value;
      setTitleCheck(false);
    } else {
      setTitleCheck(true);
    }
  };
  // Note to be displayed if user enters wrong input for Model title
  const errorNote = titleCheck ? <span style={errorredNote}>{ERRORNOTETEXT}</span> : <span style={modelUploadNote(theme)}>{ERRORNOTETEXT}</span>;
  return (
    <>
      <Button style={twinButton(theme)} onClick={showModal}>
        UPLOAD MODEL <UploadOutlined />
      </Button>
      <Modal
        title="UPLOAD MODEL"
        open={isModalVisible}
        onOk={saveModel}
        onCancel={handleCancel}
        width={1000}
        bodyStyle={{ backgroundColor: "#262E40" }}
        footer={null}
        maskClosable={false}
        closable={!showProgress}
      >
        <Spin spinning={showProgress}>
          <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
            <Col className="gutter-row" span={12}>
              <div>
                <Form
                  name="model"
                  key={formKey}
                  layout="vertical"
                  initialValues={{
                    remember: true,
                  }}
                  requiredMark={false}
                >

                  <Form.Item
                    label={
                      <span>
                        Title<span style={{ color: 'red', marginLeft: 4 }}>*</span>
                      </span>
                    }
                    name="title"
                    rules={[
                      {
                        required: true,
                        message: "Please enter title!",
                      },
                    ]}
                  >
                    <Input
                      ref={inputRef}
                      maxLength={CHAR_LIMIT}
                      onKeyUp={handleTitleChange}
                      onBlur={handleTitleChange}
                      className="title"
                      style={{ border: `1px solid ${theme === "dark" ? "#1D5F70" : "#CADCF8"}` }}
                    />

                    <span style={{ display: "inline-flex", alignItems: "center" }}>
                      <ExclamationCircleFilled
                        style={{
                          color: theme === "dark" ? "#01F1FF" : "#2B6FD6",
                          fontSize: "smaller",
                          marginRight: "4px", // optional spacing between icon and text
                        }}
                      />

                      {errorNote}
                    </span>

                  </Form.Item>
                  <Form.Item label={
                    <span>
                      Tag<span style={{ color: 'red', marginLeft: 4 }}>*</span>
                    </span>
                  } name="tag" value={tag}>
                    <Input defaultValue={plantName} readOnly
                      style={{ border: `1px solid ${theme === "dark" ? "#1D5F70" : "#CADCF8"}` }} />
                  </Form.Item>
                  <Row gutter={16}>
                    <Col className="gutter-row" span={18}>
                      <Form.Item
                        name="asset"
                        label={
                          <span>
                            3D File<span style={{ color: 'red', marginLeft: 4 }}>*</span>
                          </span>
                        }
                        rules={[
                          {
                            required: true,
                          },
                        ]}
                      >
                        <Upload.Dragger
                          name="asset"
                          maxCount={1}
                          beforeUpload={() => false}
                          onChange={validateSelectedFiles}
                          onRemove={removeFile}
                        >
                          <p className="dropzone-icon"
                          >
                            <CloudUploadOutlined
                            />
                          </p>
                          <p className="dropzone-text">
                            Drag and drop the asset or click to select files.
                            Please upload GLTF or Glb file only
                          </p>
                        </Upload.Dragger>
                        {assetValidation || thumbnailValidation ? (
                          <p id="error_color">
                            {thumbnailValidation === true ? "Please upload JPG or PNG file only" : "Please upload GLTF or Glb file only"}
                          </p>
                        ) : null}
                      </Form.Item>
                    </Col>
                    <Col className="gutter-row" span={6}>
                      <Form.Item
                        label={
                          <span>
                            Thumbnail<span style={{ color: 'red', marginLeft: 4 }}>*</span>
                          </span>
                        }
                        name="Thumbnail"
                        rules={[
                          {
                            required: true,
                          },
                        ]}
                      >
                        <div className="clearfix">
                          {/* <Tooltip
                            title="Click to upload new thumbnail"
                            placement="bottomRight"
                          > */}
                          <Upload
                            {...filePropsThumbnail}
                            listType="picture-card"
                            showUploadList={false}
                            onChange={handleIcon}
                            onRemove={() => {
                              setPreviewImage(null);
                            }}
                            style={{ border: `1px solid ${theme === "dark" ? "#1D5F70" : "#CADCF8"}` }}
                          >
                            {previewImage ? (
                              <img
                                alt="preview"
                                className="imgWidth"
                                src={previewImage}
                              />
                            ) : (
                              <div>
                                <PlusOutlined />
                                <div className="ant-upload-text">
                                  Upload thumbnail
                                </div>
                              </div>
                            )}
                          </Upload>
                          {/* </Tooltip> */}
                          {/* <p id="thumbnail_error"></p> */}
                        </div>
                      </Form.Item>
                    </Col>
                  </Row>
                  {isUpload ? (
                    <Progress
                      strokeColor={{
                        "0%": "#108ee9",
                        "100%": "#87d068",
                      }}
                      percent={uploadPercentage}
                    />
                  ) : null}
                </Form>
              </div>
            </Col>
            <Col className="gutter-row" span={12}>
              <div>
                <model-viewer
                  src={file}
                  shadow-intensity="1"
                  camera-controls
                  auto-rotate
                  ar
                  class="modelviewerStyle"
                >
                  <div id="lazy-load-poster" slot="poster"></div>
                  <div id="button-load" slot="poster">
                    <PlayCircleOutlined /> Preview
                  </div>
                </model-viewer>
              </div>
            </Col>
          </Row>
          <Divider style={{ border: "0px" }} />
          <Row>
            <Col span={8}>
              <Button className="cancelButton" onClick={handleCancel}>
                Cancel{" "}
              </Button>
            </Col>
            <Col span={8} offset={8} className="divAlignRight">
              <Button className="model-confirm-yes"
                style={{
                  backgroundColor: isSaving || titleCheck || inputRef?.current?.input?.value?.length < 3 ? "#7a7a7a" : "#1d5f70",
                  color: isSaving || titleCheck || inputRef?.current?.input?.value?.length < 3 ? "#999999" : "#01f1ff",
                  fontWeight: "700",
                  padding: "4px 64px",
                }}
                disabled={isSaving || titleCheck || inputRef?.current?.input?.value?.length < 3}
                onClick={() => saveModel()}
              >
                UPLOAD MODEL
              </Button>
            </Col>
          </Row>
        </Spin>
      </Modal>
    </>
  );
};

export default AssetUpload;
